import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './App.css';
import Layout_responsive from './layout/MainPage/Layout_responsive';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-jquery-plugin';
import PulseLoader from 'react-spinners/PulseLoader';
import Message from './utils/Message/Message';
import axios from 'axios';
import GeneralContext from './context/GeneralContext';
import useToken from './useToken';
import { onLogin } from './redux/auth.slice';
import Login from './layout/LoginPage/Login/Login';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { onConnection } from './redux/connection.slice';
import {
  setbackEndUrl,
  setDefaultTeams, setErpType,
  setServer_gmt
} from './redux/search.slice';
import { store } from './store';
import {getLocalUtcOffSetValue} from "./utils/Methods/methods";
import {setupAxios} from "./axios.config";
import { initDefaultOrganization } from './services/Users/Users';
require('dotenv').config();
export const loadingShow = (val: any, message = '') => {
  let loading = $('.splash-screen');
  $('#message-loading').html(message);
  if (val) {
    loading.css('visibility', 'visible');
  } else {
    loading.css('visibility', 'hidden');
  }
};
export let serviceUrl = 'https://data.uwork.com.au';
export var all_information: any = {};
const App1 = () => {
  var defaultteams = useSelector((state: any) => state.search.defaultTeams);
  var gmt = useSelector((state: any) => state.search.server_gmt);

  const Dispatch = useDispatch();

  const { userToken } = useSelector((state: any) => state.auth);
  const { token } = useToken();
  const dispatch = useDispatch();

    const getServerGmt = async () => {
    try {
      // const response = await fetch('./config.json');
      // const config = await response.json();
      //let gmt = config.SERVER_GMT;
      let gmt =11;
      let drawerOffsetValue = getLocalUtcOffSetValue();
      if(!isNaN(drawerOffsetValue)) {
        gmt = drawerOffsetValue / -60;
      }
      Dispatch(setServer_gmt(gmt));
      return gmt;
    } catch (error) {
      console.log(error);
      return '';
    }
  };
  const FetchServerGmt = async () => {
    await getServerGmt();
    fetchData();
  };

  const getErpType = async () => {
    try {
      const response = await fetch('./config.json');
      const config = await response.json();
      const erp = config.REACT_APP_ERP_TYPE;
      Dispatch(setErpType(erp));
      return erp;
    } catch (error) {
      console.log(error);
      return 'PRONTO';
    }
  };
  const fetchErpType = async () => {
    await getErpType();
  };

  const getbackendUrl = async () => {
    try {
      const response = await fetch('./config.json');
      const config = await response.json();
      const api = config.REACT_APP_API_GLOBAL_URL;
      Dispatch(setbackEndUrl(api));
      return api;
    } catch (error) {
      console.log(error);
      return '';
    }
  };
  const FetchBackendUrl = async () => {
    await getbackendUrl();
    setupAxios();
    fetchData();
  };

  const fetchData = async () => {
    if (token) {
      loadingShow(true, 'Preparing...');
      await fetchTheCurrentUser(token);
    }
  };

  useEffect(() => {
    FetchBackendUrl();
    fetchErpType();
    FetchServerGmt();
    if (
      defaultteams.length === 0 ||
      defaultteams === null ||
      defaultteams === undefined
    ) {
      if (
        localStorage.getItem('defaultTeams') != '' ||
        localStorage.getItem('defaultTeams') != null ||
        localStorage.getItem('defaultTeams') != undefined
      ) {
        var templist: number[] = [];

        localStorage
          .getItem('defaultTeams')
          ?.split(',')
          .map((item) => {
            templist.push(parseInt(item));
          });

        Dispatch(setDefaultTeams(templist));
      }
    }
  }, []);

  const fetchTheCurrentUser = async (token: string) => {
    const state = store.getState();
    const backEndUrl = state.search.backEndUrl;

    const headers = { Authorization: `Bearer ${token}` }; // auth header with bearer token
    await axios
      .get(backEndUrl + 'auth/profile', { headers })
      .then((res) => {
        // const data = JSON.parse(res.data);
        const gmt: number = res.data.gmt;
        Dispatch(setServer_gmt(gmt));
        if (!res.data.error) {
          if (res.data.status_code) {
            if (res.data.status_code === 401) {
              Message.error('Unauthorized login');
              return;
            }
          }
          loadingShow(false);
          if (res.data !== '' && res.data) {
            callBackData(res.data, token);
          } else {
            Message.error('Unauthorized login');
          }
        } else {
          Message.error('Something went wrong');
        }
      })
      .catch((err) => {
        if (err.isAxiosError) {
          if (err?.response?.data?.status_code === 401) {
            Message.warning('Unauthorized login. Try again');
          }
        } else {
          Message.error('Something went wrong');
        }
        loadingShow(false);
      });
  };
  useEffect(() => {
    if (userToken) {
      // all_information = restOfData;
    }
  }, [userToken]);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const callBackData = async (data: any, tokken: string) => {
    let theComponents: Array<any> = data.theComponents;
    let theRole = data.isAdminRole;
    if (data.lock_account) {
      Message.error(
        'This account has been blocked. Please reach out your admin. '
      );
      return;
    }
    // if (!data.status_id) {
    //   Message.error('Non-active user. Please reach out your admin.');
    //   return;
    // }
    if (theComponents.length === 0 && !theRole) {
      Message.error('Non Authorize user. Please reach out your admin');
      return;
    }

    try {
      await initDefaultOrganization(tokken);
    } catch (err) {
      console.error('Default org init failed', err);
    }

    all_information = data;
    all_information.token = tokken;
    dispatch(onLogin({ tokken: tokken, restOfData: data }));
  };
  useEffect(() => {
    dispatch(onConnection(navigator.onLine));
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener('online', handleStatusChange);
    window.addEventListener('offline', handleStatusChange);

    return () => {
      window.removeEventListener('online', handleStatusChange);
      window.removeEventListener('offline', handleStatusChange);
    };
  }, [isOnline]);

  return (
    <GeneralContext>
      <div>
        <div className='splash-screen'>
          <div className='loading-text'>
            <PulseLoader color='#9013FE' size={13} margin={2} />
          </div>
          <div id='message-loading'></div>
        </div>
        <div className='App'>
          {userToken && (
            <Layout_responsive
              fetchTheCurrentUser={fetchTheCurrentUser.bind(this)}
            />
          )}
          {!userToken && (
            <Login fetchTheCurrentUser={fetchTheCurrentUser.bind(this)} />
          )}
          <ToastContainer autoClose={1800} />
          <DialogComponent
            isModal={true}
            id='defaultdialogNoConnwction'
            animationSettings={{ delay: 3, effect: 'Zoom' }}
            visible={false}
            width={'300'}
          ></DialogComponent>
        </div>
      </div>
    </GeneralContext>
  );
};
export default App1;
export const GetBackendUrlForGlobalFunctions = () => {
  const state = store.getState(); // Redux store'dan state'i çekiyoruz
  const backEndUrl = state.search.backEndUrl;
  return backEndUrl;
};
export const GetServerGmt = () => {
  const state = store.getState();
  const serverGmt = state.search.server_gmt;
  return serverGmt;
};

export const GetErpTypeFromConfig = () => {
  const state = store.getState();
  const erpType = state.search.erpType;
  return erpType;
};
